import { useNavigate } from "react-router-dom";
import React from "react";
import { MoveLeft } from "lucide-react";
import styles from "../teams/components/TeamSettings.module.css";
import { setHasSeenTeamDemo } from "../teams/teamDemoStorage";

const TeamDemoNextSteps = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <div className="settings-element-header">
        <MoveLeft
          onClick={() => navigate("/app/demo-team")}
          className={styles["back-button"]}
          aria-label="Back"
        />
        <p className={`settings-element-title page-title`}>Get started</p>
        <div className={styles["team-settings-header-spacer"]} aria-hidden />
      </div>

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          padding: "16px",
          paddingBottom: "max(16px, env(safe-area-inset-bottom, 0px))",
        }}
      >
        <button
          type="button"
          className="proceed-button"
          onClick={() => {
            setHasSeenTeamDemo();
            navigate("/app/demo-team/login");
          }}
        >
          Add your team
        </button>
        <button
          type="button"
          className="proceed-button"
          onClick={() => navigate("/app/demo-team/join-code")}
        >
          Join existing team
        </button>
      </div>
    </div>
  );
};

export default TeamDemoNextSteps;
